import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import { inviteFormType } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import InviteUser from '../servicer-users/InviteUser';
import PromoterUserTable from './PromoterUserTable';
import { ListContainer } from 'components';

const PromoterUsers = () => {
    const { path } = useRouteMatch();

    return (
        <ListContainer>
            <Switch>
                <Route
                    path={`${path}/invite-promoter`}
                    render={() => (
                        <InviteUser
                            title={texts.PROMOTER_CREATE_USER}
                            type={inviteFormType.PROMOTER}
                        />
                    )}
                />
                <Route path={path} component={PromoterUserTable} />
            </Switch>
        </ListContainer>
    );
};

export default PromoterUsers;
